import {OPTIMISTIC_KEY} from '@github-ui/optimistic-connection'

/**
 * Stable identity for a timeline row. `__id` wins so keys match what the Relay path produced; a
 * TanStack-backed timeline has no `__id` and is keyed by the server `id`.
 */
export type TimelineItemIdentity =
  | {readonly __id: string; readonly id?: string}
  | {readonly id: string; readonly [OPTIMISTIC_KEY]?: string}

export function timelineItemKey(item: TimelineItemIdentity): string {
  if ('__id' in item) return item.__id
  // The confirmed node carries a different, server-issued id, so keying off it would remount the
  // whole comment exactly as the write lands. The correlation key is stable across that swap.
  return item[OPTIMISTIC_KEY] ?? item.id
}
